module.exports = __webpack_public_path__ + "img/img5.9e9f4f03.png";